// NOTE: Keep in sync with web-frontend's src/lib/FormLib/data/states.ts

import { counties } from './counties';
import { municipalities } from './municipalities';

export const stateNames = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

const devEnableAllStates = location.search.includes('internal-enable-all-states');

const supportedStates = {
  // These are states that we support in general,
  // `:true` means that we support it in the calculator
  AZ: true,
  CO: true,
  CT: true,
  DC: false,
  FL: true,
  GA: true,
  IL: true,
  IN: true,
  KS: true,
  KY: false,
  MA: true,
  MD: true,
  ME: true,
  MI: true,
  MN: false,
  MO: true,
  MT: true,
  NC: true,
  ND: false,
  NE: false,
  NH: false,
  NJ: true,
  OH: true,
  OK: true,
  PA: true,
  RI: false,
  SC: true,
  TN: true,
  TX: true,
  UT: true,
  VA: true,
  VT: false,
  WI: true,
  WV: false,
};

const supportedInCalculator = new Set(
  Object.keys(supportedStates).filter((state) => supportedStates[state] || devEnableAllStates),
);
const supportedOutsideCalculator = new Set(
  Object.keys(supportedStates).filter((state) => !supportedStates[state]),
);

// NOTE: Keep in sync with src/lib/FormLib/predefined/questionnaires/buyer/common_insurance.ts
export const statesWithInsurance = [
  'MD',
  'TN',
  'AZ',
  'WV',
  'GA',
  'UT',
  'MI',
  'NC',
  'WI',
  'VA',
  'PA',
  'SC',
  'OH',
  'CT',
  'DC',
  'KY',
  'NE',
  'MN',
  'NH',
  'MT',
  'RI',
  'ND',
  'IN',
  'CO',
];

const supportedTexasCounties = [
  'Atascosa',
  'El Paso',
  'Medina',
  'Bastrop',
  'Ellis',
  'Midland',
  'Bell',
  'Fort Bend',
  'Montgomery',
  'Bexar',
  'Galveston',
  'Nueces',
  'Blanco',
  'Grayson',
  'Parker',
  'Brazoria',
  'Guadalupe',
  'Potter',
  'Brazos',
  'Harris',
  'Randall',
  'Burnet',
  'Hays',
  'Rockwall',
  'Caldwell',
  'Hidalgo',
  'San Patricio',
  'Cameron',
  'Hood',
  'Smith',
  'Chambers',
  'Hunt',
  'Tarrant',
  'Collin',
  'Jefferson',
  'Travis',
  'Comal',
  'Johnson',
  'Victoria',
  'Cooke',
  'Kaufman',
  'Walker',
  'Dallas',
  'Kendall',
  'Waller',
  'Denton',
  'Liberty',
  'Williamson',
  'Ector',
  'Llano',
  'Wise',
];

export const STATES_DATA = Object.entries(stateNames)
  .map(([state_code, state_name]) => ({
    state_name,
    state_code,
    is_active: supportedInCalculator.has(state_code),
    isSupportedOutsideCalculator: supportedOutsideCalculator.has(state_code),
    has_insurance: statesWithInsurance.includes(state_code),
    counties: counties[state_code] || [],
    municipalities: municipalities[state_code],
    supportedCounties: state_code === 'TX' ? supportedTexasCounties : null,
    needsLandType: ['CT', 'DC'].includes(state_code),
    needsPrimaryResidence: ['MD'].includes(state_code),
    needsFirstTimeHomebuyer: ['MD', 'DC'].includes(state_code),
  }))
  .sort((a, b) => a.state_name.localeCompare(b.state_name));
